import { $uniUP } from "../.."

export interface DialogFormFactory {
  new(opts?: any): IDialogForm
}

export type TDialogOptions = { title?: string }

export interface IDialogForm {
  activo: boolean
  title: string

  open: (...opts: any[]) => void
  close: () => void
}

export class DialogFormProxy implements IDialogForm {
  args: { [key: string]: string | any }
  activo: boolean
  title: string

  constructor(opts?: TDialogOptions) {
    this.activo = false
    opts && opts.title && (this.title = opts.title)
  }

  open(...opts: any[]) {
    this.args = opts
    this.activo = true
  }

  close() {
    this.activo = false
  }
}

/*
    class DialogFormFactory {
        // new: (opts?: any) => DialogForm

        constructor(opts?: any) {
            
        }

        new(opts?: any) {
            return function (opts) {
                return new DialogFormProxy(this.$http, this.$log, this.UniConfig, opts);
            }
        }
    }
    */

$uniUP.factory("DialogFormFactory", () => (opts?: any) =>
  new DialogFormProxy(opts)
)

  // para instanciar up.DialogFormProxy necesario para extender en unitec
  ; ((window as any).up =
    (window as any).up || {}).DialogFormProxy = DialogFormProxy
